.checkbox {
  display: inline-flex;
  gap: var(--space-3);
  align-items: center;
  min-height: var(--touch-target);
  cursor: pointer;
}

.input {
  flex: none;
  width: var(--space-5);
  height: var(--space-5);
  accent-color: var(--action);
  cursor: pointer;
}

.label {
  font-size: var(--text-base);
  color: var(--text-primary);
}
